import React from 'react';
import { Form, Select } from "antd";
import Icons from "components/icons";
import { Localize } from "components/service";


const UserStatusSelect = ({
    disabled = false,
    rules = false,
    initialValue,
    mode = '',
    form,
    name = 'status',
    onChangeSetFilter = () => { },
    label = Localize({ children: "FORMS.Input_Label_Status" }).props.children
}) => {


    return (
        <Form.Item
            name={ name }
            label={ label }
            initialValue={ initialValue }
            rules={ rules && [ { required: true, message: `${ Localize({ children: "FORM_RULES.Required_Choose" }).props.children } ${ label }` } ] }
        >
            <Select
                showSearch
                suffixIcon={ <Icons.Arrow /> }
                mode={ mode }
                className="select-serch-input"
                disabled={ disabled }
                placeholder={ `${ Localize({ children: "FORMS.Input_Placeholder_Choose" }).props.children } ${ label }` }
                popupClassName="select-serch-dropdown"
                optionFilterProp="value"
                onChange={
                    (value) => {
                        form.setFieldsValue({ [ name ]: value });
                        onChangeSetFilter(false, name, value);
                    } }
            >
                <Select.Option key="active" value="active"><Localize>FORMS.Select_OptionLabel_Active</Localize> </Select.Option>
                <Select.Option key="inactive" value="inactive"><Localize>FORMS.Select_OptionLabel_Inactive</Localize> </Select.Option>
                <Select.Option key="block" value="block"><Localize>FORMS.Select_OptionLabel_Block</Localize> </Select.Option>
            </Select>
        </Form.Item>
    );

}

export default UserStatusSelect;


